import React from 'react';
import clsx from 'clsx';
import {withStyles} from '@mui/styles';
import PencilIcon from '../../../icons/PencilIcon';
import Button from '@mui/material/Button';
import style from './BaseSingleViewHeader.module.scss';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const styles = theme => {
    return ({
        introBar: {
            background: theme.palette.primary.main,
            padding: `30px 0 30px`,
            minHeight: '102px'
        },
        introBarTitle: {
            color: 'white',
            fontSize: '27px',
            lineHeight: '38px'
        },
        introBarSubtitle: {
            color: 'white',
            fontSize: '20px',
            lineHeight: '29px'
        },
        infoWidgetWrapper: {
            position: 'relative',
            top: '-48px',
            margin: '0 0 -48px'
        },
        infoWidgetRow: {
            margin: '0 -25px',
            display: 'flex',
            alignItems: 'flex-start'
        },

        infoWidgetTitle: {
            padding: '10px 13px 10px 27px',
            fontSize: '19px',
            lineHeight: '27px',
        },
        editButton: {
            border: 'none !important',
            textTransform: 'none !important',
            fontWeight: '700 !important',
            fontSize: '20px !important',
            color: 'white !important',
            transition: 'opacity .5s !important',
            padding: '5px 15px !important',
            letterSpacing: '0 !important',
            '&:hover': {
                background: 'none',
                opacity: '.5',
            },
            '& svg': {
                width: 17,
                height: 17,
                color: 'white',
                margin: '0 17px 0 0'
            }
        }
    });
}

const BaseSingleViewHeader = (props) => {
    const { classes, editLink, title, subtitle } = props;
    const navigate = useNavigate();

    return (
        <div className={classes.root}>
            <div className={classes.introBar}>
                <div className={clsx({
                    'singlePage__container': true,
                    [style.introBarContainer]: true,
                })}>
                    <div className={classes.introBarTitle}>
                        {title}
                        <div className={classes.introBarSubtitle}>
                            {subtitle}
                        </div>
                    </div>
                    <div className={classes.introBarEditBtn}>
                        <Button onClick={() => navigate(editLink)} variant="outlined" color="default" className={classes.editButton}>
                            <PencilIcon/>
                            Edit
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

BaseSingleViewHeader.propTypes = {
    data: PropTypes.object.isRequired,
}


BaseSingleViewHeader.defaultProps = {
    editLink: null,
    title: '',
    subtitle: '',
    data: {},
    viewInputsByHash: {},
    viewGroupsById: [],
    viewGroupsByHash: {}
}

export default withStyles(styles)(BaseSingleViewHeader);